module.exports = __webpack_public_path__ + "static/media/handShakeGrey.4b492ed2.svg";